import { useTheme } from "@hooks/useTheme";

const TreeNode = ({ node, isRoot }) => {
  const { colors } = useTheme();

  return (
    <li
      className="relative pl-6 py-1 list-none"
      data-testid={`sbom-tree-node${isRoot ? "-root" : ""}${node.label ? `-${String(node.label).toLowerCase().replace(/\s+/g, "-")}` : ""}`}
    >
      {/* L connector (skip for root) */}
      {!isRoot && (
        <>
          <span className={`absolute left-0 top-0 h-[1.1em] border-l ${colors.borderMuted}`}></span>
          <span className={`absolute left-0 top-[1.1em] w-4 border-t ${colors.borderMuted}`}></span>
        </>
      )}

      {/* Label + icon */}
      <div className="flex items-center">
        {node.icon && (
          <span className={`mr-2 ${colors.textNeutralMuted}`}>
            <node.icon size={14} />
          </span>
        )}
        <span
          className={`text-[0.8125rem] font-normal ${colors.textMessage}`}
        >
          {node.label}
        </span>
      </div>

      {/* Children */}
      {node.children && (
        <ul className="ml-1.5">
          {node.children.map((child, idx) => (
            <TreeNode key={idx} node={child} />
          ))}
        </ul>
      )}
    </li>
  );
};

export default TreeNode;
